import React from 'react';
import { Menu, Settings, Info, LogOut, Download, User } from 'lucide-react';

const Header = ({ user, showMenu, setShowMenu, setShowAccountManager, setShowAbout, handleSignOut, handleExportData }) => {
  return (
    <div className="bg-white border-b border-gray-100 px-4 sm:px-8 py-4">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <span className="text-gray-900 font-semibold tracking-tight text-[15px]">Monthly Wealth Tracker</span>

        {/* Mobile */}
        <div className="relative lg:hidden">
          <button
            onClick={() => setShowMenu(!showMenu)}
            className="p-1.5 text-gray-400 hover:text-gray-900 transition-colors rounded-lg hover:bg-gray-50"
          >
            <Menu className="w-5 h-5" />
          </button>

          {showMenu && (
            <>
              <div className="fixed inset-0 z-10" onClick={() => setShowMenu(false)} />
              <div className="absolute right-0 top-full mt-2 w-56 bg-white border border-gray-100 rounded-xl shadow-card z-20 overflow-hidden">
                <div className="px-4 py-3 border-b border-gray-100">
                  <p className="text-sm text-gray-900 truncate">{user?.displayName || 'User'}</p>
                  <p className="text-xs text-gray-400 truncate mt-0.5">{user?.email}</p>
                </div>
                {[
                  { icon: Settings, label: 'Manage Accounts', action: () => { setShowAccountManager(true); setShowMenu(false); } },
                  { icon: Download, label: 'Export Data', action: () => { handleExportData(); setShowMenu(false); } },
                  { icon: Info, label: 'About', action: () => { setShowAbout(true); setShowMenu(false); } },
                  { icon: LogOut, label: 'Sign Out', action: () => { handleSignOut(); setShowMenu(false); } },
                ].map(({ icon: Icon, label, action }) => (
                  <button
                    key={label}
                    onClick={action}
                    className="w-full px-4 py-2.5 text-left flex items-center gap-3 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors"
                  >
                    <Icon className="w-4 h-4" />
                    {label}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>

        {/* Desktop */}
        <div className="hidden lg:flex items-center gap-1">
          {[
            { icon: Settings, label: 'Manage Accounts', action: () => setShowAccountManager(true) },
            { icon: Download, label: 'Export Data', action: handleExportData },
            { icon: Info, label: 'About', action: () => setShowAbout(true) },
          ].map(({ icon: Icon, label, action }) => (
            <button
              key={label}
              onClick={action}
              className="px-3 py-1.5 flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 hover:bg-gray-50 rounded-lg transition-colors"
            >
              <Icon className="w-4 h-4" />
              {label}
            </button>
          ))}

          <div className="relative ml-2">
            <button
              onClick={() => setShowMenu(!showMenu)}
              className="px-3 py-1.5 flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 border border-gray-200 hover:border-gray-300 rounded-lg transition-colors"
            >
              <User className="w-4 h-4" />
              <span className="max-w-[140px] truncate">{user?.displayName || 'User'}</span>
            </button>

            {showMenu && (
              <>
                <div className="fixed inset-0 z-10" onClick={() => setShowMenu(false)} />
                <div className="absolute right-0 top-full mt-2 w-56 bg-white border border-gray-100 rounded-xl shadow-card z-20 overflow-hidden">
                  <div className="px-4 py-3 border-b border-gray-100">
                    <p className="text-sm text-gray-900 truncate">{user?.displayName || 'User'}</p>
                    <p className="text-xs text-gray-400 truncate mt-0.5">{user?.email}</p>
                  </div>
                  <button
                    onClick={() => { handleSignOut(); setShowMenu(false); }}
                    className="w-full px-4 py-2.5 text-left flex items-center gap-3 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors"
                  >
                    <LogOut className="w-4 h-4" />
                    Sign Out
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
